export interface Video {
  id: string;
  title: string;
  cover: string;
  category: string;
  categoryLabel: string;
  genre: string;
  year: number;
  region: string;
  tags: string[];
  rating: number;
  summary: string;
  featured: boolean;
  addedAt: string;
}

export const videos: Video[] = [
  {
    id: 'v1001',
    title: '星际迷航者',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20film%20poster%20of%20a%20lone%20astronaut%20standing%20before%20a%20giant%20glowing%20orange%20planet%2C%20warm%20amber%20and%20deep%20charcoal%20tones%2C%20dramatic%20volumetric%20lighting%2C%20atmospheric%20depth%2C%20high%20detail%2C%20moody%20elegant%20composition%2C%20professional%20color%20grading%2C%20no%20text&width=600&height=338&seq=tx-movie-01&orientation=landscape',
    category: 'movie',
    categoryLabel: '电影',
    genre: '科幻',
    year: 2026,
    region: '美国',
    tags: ['太空', '冒险', '视觉大片'],
    rating: 9.1,
    summary: '一支深空探索小队在未知星系失联，幸存者必须在燃料耗尽前找到归途，并揭开古老文明的秘密。',
    featured: true,
    addedAt: '2026-09-28',
  },
  {
    id: 'v1002',
    title: '城市之光',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20film%20poster%20of%20a%20rainy%20night%20city%20street%20with%20warm%20orange%20streetlights%20and%20a%20silhouette%20walking%20away%2C%20warm%20amber%20and%20deep%20charcoal%20tones%2C%20dramatic%20volumetric%20lighting%2C%20atmospheric%20depth%2C%20high%20detail%2C%20moody%20elegant%20composition%2C%20professional%20color%20grading%2C%20no%20text&width=600&height=338&seq=tx-movie-02&orientation=landscape',
    category: 'movie',
    categoryLabel: '电影',
    genre: '剧情',
    year: 2025,
    region: '中国大陆',
    tags: ['都市', '人情', '治愈'],
    rating: 8.6,
    summary: '一名深夜出租车司机穿行在城市霓虹之间，载着形形色色的乘客，也慢慢拼凑出自己失落的过去。',
    featured: true,
    addedAt: '2026-09-20',
  },
  {
    id: 'v1003',
    title: '无声告白',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20film%20poster%20of%20a%20mysterious%20abandoned%20mansion%20window%20glowing%20dim%20amber%2C%20fog%20and%20secrets%2C%20warm%20amber%20and%20deep%20charcoal%20tones%2C%20dramatic%20volumetric%20lighting%2C%20atmospheric%20depth%2C%20high%20detail%2C%20moody%20elegant%20composition%2C%20no%20text&width=600&height=338&seq=tx-movie-03&orientation=landscape',
    category: 'movie',
    categoryLabel: '电影',
    genre: '悬疑',
    year: 2024,
    region: '韩国',
    tags: ['推理', '反转', '烧脑'],
    rating: 8.9,
    summary: '一封没有署名的信打破了小镇的平静，记者循着蛛丝马迹调查，却发现真相与自己的家人紧密相连。',
    featured: true,
    addedAt: '2026-09-12',
  },
  {
    id: 'v1004',
    title: '山海寻踪',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20film%20poster%20of%20a%20misty%20ancient%20mountain%20range%20with%20a%20lone%20traveler%20seen%20from%20behind%2C%20warm%20amber%20and%20deep%20charcoal%20tones%2C%20dramatic%20volumetric%20lighting%2C%20atmospheric%20depth%2C%20high%20detail%2C%20epic%20elegant%20composition%2C%20professional%20color%20grading%2C%20no%20text&width=600&height=338&seq=tx-movie-04&orientation=landscape',
    category: 'movie',
    categoryLabel: '电影',
    genre: '冒险',
    year: 2025,
    region: '中国大陆',
    tags: ['探险', '神话', '东方美学'],
    rating: 8.2,
    summary: '少年为寻找传说中的神兽遗迹踏上旅程，穿越山海与荒漠，在旅途中重新认识了勇气与羁绊。',
    featured: false,
    addedAt: '2026-09-05',
  },
  {
    id: 'v1005',
    title: '深夜食堂客',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20film%20poster%20of%20a%20cozy%20late%20night%20small%20restaurant%20counter%20with%20warm%20hanging%20lamps%20and%20steam%2C%20warm%20amber%20and%20deep%20charcoal%20tones%2C%20soft%20volumetric%20lighting%2C%20atmospheric%20depth%2C%20high%20detail%2C%20warm%20intimate%20composition%2C%20no%20text&width=600&height=338&seq=tx-movie-05&orientation=landscape',
    category: 'movie',
    categoryLabel: '电影',
    genre: '剧情',
    year: 2023,
    region: '日本',
    tags: ['美食', '治愈', '人生'],
    rating: 8.8,
    summary: '一间只在午夜营业的小店，每道菜背后都藏着一段人生，食客在热气腾腾里找到慰藉与重逢。',
    featured: false,
    addedAt: '2026-08-30',
  },
  {
    id: 'v1006',
    title: '逆风奔跑',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20film%20poster%20of%20a%20runner%20sprinting%20on%20a%20track%20at%20golden%20sunset%2C%20motion%20blur%20and%20dust%2C%20warm%20amber%20and%20deep%20charcoal%20tones%2C%20dramatic%20backlight%2C%20atmospheric%20depth%2C%20high%20detail%2C%20inspiring%20composition%2C%20no%20text&width=600&height=338&seq=tx-movie-06&orientation=landscape',
    category: 'movie',
    categoryLabel: '电影',
    genre: '运动',
    year: 2024,
    region: '中国大陆',
    tags: ['热血', '励志', '青春'],
    rating: 7.9,
    summary: '出身小城的短跑少年被教练一眼看中，面对伤病与质疑，他用一次次起跑证明自己不属于替补席。',
    featured: false,
    addedAt: '2026-08-22',
  },
  {
    id: 'v1007',
    title: '幻境迷城',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20film%20poster%20of%20a%20surreal%20floating%20city%20with%20glowing%20amber%20architecture%20and%20mirrored%20skies%2C%20warm%20amber%20and%20deep%20charcoal%20tones%2C%20dramatic%20volumetric%20lighting%2C%20atmospheric%20depth%2C%20high%20detail%2C%20dreamlike%20elegant%20composition%2C%20no%20text&width=600&height=338&seq=tx-movie-07&orientation=landscape',
    category: 'movie',
    categoryLabel: '电影',
    genre: '奇幻',
    year: 2026,
    region: '英国',
    tags: ['奇幻', '梦境', '视觉'],
    rating: 8.4,
    summary: '一名建筑师发现自己设计的城市会在午夜变成迷宫，只有解开自己埋下的谜题，才能回到现实。',
    featured: false,
    addedAt: '2026-08-15',
  },
  {
    id: 'v1008',
    title: '归途列车',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20film%20poster%20of%20an%20old%20train%20crossing%20a%20vast%20golden%20landscape%20at%20dusk%2C%20warm%20amber%20and%20deep%20charcoal%20tones%2C%20dramatic%20sunset%20lighting%2C%20atmospheric%20depth%2C%20high%20detail%2C%20nostalgic%20composition%2C%20no%20text&width=600&height=338&seq=tx-movie-08&orientation=landscape',
    category: 'movie',
    categoryLabel: '电影',
    genre: '公路',
    year: 2022,
    region: '法国',
    tags: ['旅途', '亲情', '温情'],
    rating: 8.1,
    summary: '一对多年未见的父子踏上一趟漫长的绿皮火车，跨越半个国家，也跨越了彼此之间沉默的心结。',
    featured: false,
    addedAt: '2026-08-08',
  },
  {
    id: 'v2001',
    title: '长夜将明',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20tv%20poster%20of%20a%20detective%20silhouette%20under%20a%20single%20warm%20streetlamp%20in%20a%20dark%20alley%2C%20warm%20amber%20and%20deep%20charcoal%20tones%2C%20dramatic%20volumetric%20lighting%2C%20atmospheric%20depth%2C%20high%20detail%2C%20tense%20elegant%20composition%2C%20no%20text&width=600&height=338&seq=tx-tv-01&orientation=landscape',
    category: 'tv',
    categoryLabel: '电视剧',
    genre: '犯罪',
    year: 2026,
    region: '中国大陆',
    tags: ['刑侦', '正邪', '群像'],
    rating: 9.0,
    summary: '老刑警与年轻搭档联手追查一桩尘封旧案，在层层迷雾中直面人性的幽暗与光亮，正义从不缺席。',
    featured: true,
    addedAt: '2026-09-30',
  },
  {
    id: 'v2002',
    title: '我们的十年',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20tv%20poster%20of%20a%20group%20of%20young%20friends%20on%20a%20rooftop%20at%20golden%20sunset%20seen%20from%20behind%2C%20warm%20amber%20and%20deep%20charcoal%20tones%2C%20soft%20warm%20lighting%2C%20atmospheric%20depth%2C%20high%20detail%2C%20nostalgic%20composition%2C%20no%20text&width=600&height=338&seq=tx-tv-02&orientation=landscape',
    category: 'tv',
    categoryLabel: '电视剧',
    genre: '青春',
    year: 2025,
    region: '中国大陆',
    tags: ['校园', '成长', '友情'],
    rating: 8.5,
    summary: '从高中到职场，五个好友用十年时间学会告别与重逢，在各自的人生里守护着那份最初的热烈。',
    featured: true,
    addedAt: '2026-09-18',
  },
  {
    id: 'v2003',
    title: '凤鸣朝歌',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20historical%20tv%20poster%20of%20an%20ancient%20chinese%20palace%20with%20glowing%20amber%20lanterns%20and%20red%20curtains%2C%20warm%20amber%20and%20deep%20charcoal%20tones%2C%20dramatic%20volumetric%20lighting%2C%20atmospheric%20depth%2C%20high%20detail%2C%20epic%20elegant%20composition%2C%20no%20text&width=600&height=338&seq=tx-tv-03&orientation=landscape',
    category: 'tv',
    categoryLabel: '电视剧',
    genre: '古装',
    year: 2025,
    region: '中国大陆',
    tags: ['权谋', '传奇', '大制作'],
    rating: 8.3,
    summary: '乱世之中，出身低微的女子凭借过人的智慧步入朝堂，在权谋漩涡里守护家国，也书写自己的传奇。',
    featured: false,
    addedAt: '2026-09-10',
  },
  {
    id: 'v2004',
    title: '医者仁心',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20medical%20tv%20poster%20of%20a%20hospital%20corridor%20with%20warm%20amber%20light%20and%20a%20doctor%20walking%20away%2C%20warm%20amber%20and%20deep%20charcoal%20tones%2C%20soft%20dramatic%20lighting%2C%20atmospheric%20depth%2C%20high%20detail%2C%20hopeful%20elegant%20composition%2C%20no%20text&width=600&height=338&seq=tx-tv-04&orientation=landscape',
    category: 'tv',
    categoryLabel: '电视剧',
    genre: '医疗',
    year: 2024,
    region: '中国大陆',
    tags: ['职场', '温情', '现实'],
    rating: 8.7,
    summary: '急诊科医生在抢救生命的日夜里，面对制度、亲情与理想的多重考验，用专业与善意托住每一个家庭。',
    featured: false,
    addedAt: '2026-09-02',
  },
  {
    id: 'v2005',
    title: '都市浮生记',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20tv%20poster%20of%20a%20modern%20city%20skyline%20at%20dusk%20with%20warm%20amber%20window%20lights%2C%20warm%20amber%20and%20deep%20charcoal%20tones%2C%20dramatic%20volumetric%20lighting%2C%20atmospheric%20depth%2C%20high%20detail%2C%20urban%20elegant%20composition%2C%20no%20text&width=600&height=338&seq=tx-tv-05&orientation=landscape',
    category: 'tv',
    categoryLabel: '电视剧',
    genre: '都市',
    year: 2023,
    region: '中国大陆',
    tags: ['生活', '群像', '共鸣'],
    rating: 8.0,
    summary: '住在同一栋老楼里的几户人家，在柴米油盐与理想现实之间彼此扶持，演绎平凡生活里的动人故事。',
    featured: false,
    addedAt: '2026-08-25',
  },
  {
    id: 'v2006',
    title: '悬案档案',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20tv%20poster%20of%20a%20dim%20archive%20room%20with%20stacked%20files%20and%20a%20warm%20amber%20desk%20lamp%2C%20warm%20amber%20and%20deep%20charcoal%20tones%2C%20dramatic%20focused%20lighting%2C%20atmospheric%20depth%2C%20high%20detail%2C%20mysterious%20elegant%20composition%2C%20no%20text&width=600&height=338&seq=tx-tv-06&orientation=landscape',
    category: 'tv',
    categoryLabel: '电视剧',
    genre: '悬疑',
    year: 2026,
    region: '韩国',
    tags: ['单元剧', '推理', '反转'],
    rating: 8.9,
    summary: '每一集重启一桩悬而未决的旧案，调查小组用新的技术与人性的洞察，为沉默的真相找回声音。',
    featured: false,
    addedAt: '2026-08-18',
  },
  {
    id: 'v3001',
    title: '奇妙探险家',
    cover: 'https://readdy.ai/api/search-image?query=colorful%20variety%20show%20poster%20of%20a%20group%20of%20explorers%20on%20a%20wild%20green%20mountaintop%20with%20warm%20amber%20sunlight%2C%20cheerful%20warm%20amber%20and%20deep%20charcoal%20tones%2C%20bright%20friendly%20lighting%2C%20atmospheric%20depth%2C%20high%20detail%2C%20fun%20energetic%20composition%2C%20no%20text&width=600&height=338&seq=tx-var-01&orientation=landscape',
    category: 'variety',
    categoryLabel: '综艺',
    genre: '真人秀',
    year: 2026,
    region: '中国大陆',
    tags: ['户外', '团队', '爆笑'],
    rating: 8.4,
    summary: '六位嘉宾组成探险小队，深入自然秘境完成各种脑洞任务，在欢笑与协作中挑战自我、收获友谊。',
    featured: true,
    addedAt: '2026-09-26',
  },
  {
    id: 'v3002',
    title: '声临其境夜',
    cover: 'https://readdy.ai/api/search-image?query=music%20competition%20show%20poster%20of%20a%20stage%20with%20warm%20amber%20spotlights%20and%20a%20microphone%20in%20silhouette%2C%20warm%20amber%20and%20deep%20charcoal%20tones%2C%20dramatic%20stage%20lighting%2C%20atmospheric%20depth%2C%20high%20detail%2C%20glamorous%20elegant%20composition%2C%20no%20text&width=600&height=338&seq=tx-var-02&orientation=landscape',
    category: 'variety',
    categoryLabel: '综艺',
    genre: '音乐',
    year: 2025,
    region: '中国大陆',
    tags: ['音乐', '竞演', '舞台'],
    rating: 8.7,
    summary: '实力唱将与新生代歌手同台竞演，用一首首经典与原创点燃舞台，重新定义现场音乐的感动。',
    featured: false,
    addedAt: '2026-09-14',
  },
  {
    id: 'v3003',
    title: '舌尖寻味记',
    cover: 'https://readdy.ai/api/search-image?query=food%20documentary%20poster%20of%20a%20rustic%20kitchen%20table%20with%20steaming%20dishes%20in%20warm%20amber%20light%2C%20warm%20amber%20and%20deep%20charcoal%20tones%2C%20soft%20appetizing%20lighting%2C%20atmospheric%20depth%2C%20high%20detail%2C%20warm%20inviting%20composition%2C%20no%20text&width=600&height=338&seq=tx-var-03&orientation=landscape',
    category: 'variety',
    categoryLabel: '综艺',
    genre: '美食',
    year: 2025,
    region: '中国大陆',
    tags: ['美食', '人文', '旅行'],
    rating: 8.6,
    summary: '主持人走遍大江南北的街头巷尾，寻找藏在市井里的地道风味，也讲述一碗味道背后的人情故事。',
    featured: false,
    addedAt: '2026-09-06',
  },
  {
    id: 'v3004',
    title: '欢乐喜剧场',
    cover: 'https://readdy.ai/api/search-image?query=comedy%20show%20poster%20of%20a%20warm%20amber%20lit%20small%20stage%20with%20a%20single%20spotlight%20and%20curtain%2C%20warm%20amber%20and%20deep%20charcoal%20tones%2C%20playful%20dramatic%20lighting%2C%20atmospheric%20depth%2C%20high%20detail%2C%20fun%20lively%20composition%2C%20no%20text&width=600&height=338&seq=tx-var-04&orientation=landscape',
    category: 'variety',
    categoryLabel: '综艺',
    genre: '喜剧',
    year: 2024,
    region: '中国大陆',
    tags: ['喜剧', '脱口秀', '解压'],
    rating: 8.1,
    summary: '集结人气喜剧演员与脱口秀新星，用一个个贴近生活的小品和段子，把烦恼变成这个夜晚的笑声。',
    featured: false,
    addedAt: '2026-08-28',
  },
  {
    id: 'v3005',
    title: '环球旅途日记',
    cover: 'https://readdy.ai/api/search-image?query=travel%20show%20poster%20of%20a%20winding%20coastal%20road%20at%20golden%20hour%20with%20a%20van%20driving%20into%20the%20distance%2C%20warm%20amber%20and%20deep%20charcoal%20tones%2C%20warm%20scenic%20lighting%2C%20atmospheric%20depth%2C%20high%20detail%2C%20inviting%20wanderlust%20composition%2C%20no%20text&width=600&height=338&seq=tx-var-05&orientation=landscape',
    category: 'variety',
    categoryLabel: '综艺',
    genre: '旅行',
    year: 2023,
    region: '中国大陆',
    tags: ['旅行', '慢综艺', '治愈'],
    rating: 8.3,
    summary: '嘉宾一路搭车、露营、走进当地人生活，用最慢的方式感受世界，也在旅途中与自己和解。',
    featured: false,
    addedAt: '2026-08-20',
  },
  {
    id: 'v4001',
    title: '一分钟心动',
    cover: 'https://readdy.ai/api/search-image?query=short%20video%20poster%20of%20a%20cozy%20street%20corner%20cafe%20with%20warm%20amber%20fairy%20lights%20and%20rain%20on%20the%20window%2C%20warm%20amber%20and%20deep%20charcoal%20tones%2C%20soft%20romantic%20lighting%2C%20atmospheric%20depth%2C%20high%20detail%2C%20intimate%20charming%20composition%2C%20no%20text&width=600&height=338&seq=tx-short-01&orientation=landscape',
    category: 'short',
    categoryLabel: '短视频',
    genre: '生活',
    year: 2026,
    region: '中国大陆',
    tags: ['情感', '日常', '记录'],
    rating: 7.8,
    summary: '用一分钟记录城市里那些微小却动人的瞬间，一次回头、一把共伞，都可能是一段故事的开端。',
    featured: true,
    addedAt: '2026-10-01',
  },
  {
    id: 'v4002',
    title: '街头神剪辑',
    cover: 'https://readdy.ai/api/search-image?query=short%20video%20poster%20of%20a%20neon%20warm%20amber%20city%20crossing%20with%20motion%20blur%20and%20dynamic%20streaks%2C%20warm%20amber%20and%20deep%20charcoal%20tones%2C%20dramatic%20neon%20lighting%2C%20atmospheric%20depth%2C%20high%20detail%2C%20punchy%20energetic%20composition%2C%20no%20text&width=600&height=338&seq=tx-short-02&orientation=landscape',
    category: 'short',
    categoryLabel: '短视频',
    genre: '创意',
    year: 2026,
    region: '美国',
    tags: ['剪辑', '创意', '视觉'],
    rating: 7.6,
    summary: '跟随镜头穿越城市的昼夜转换，用丝滑的转场和节奏感极强的剪辑，把普通街景变成视觉惊喜。',
    featured: false,
    addedAt: '2026-09-24',
  },
  {
    id: 'v4003',
    title: '宠物日常记',
    cover: 'https://readdy.ai/api/search-image?query=short%20video%20poster%20of%20a%20fluffy%20cat%20and%20dog%20playing%20in%20a%20sunny%20warm%20amber%20room%2C%20warm%20amber%20and%20deep%20charcoal%20tones%2C%20soft%20cozy%20lighting%2C%20atmospheric%20depth%2C%20high%20detail%2C%20adorable%20heartwarming%20composition%2C%20no%20text&width=600&height=338&seq=tx-short-03&orientation=landscape',
    category: 'short',
    categoryLabel: '短视频',
    genre: '萌宠',
    year: 2026,
    region: '中国大陆',
    tags: ['萌宠', '搞笑', '治愈'],
    rating: 8.0,
    summary: '猫猫狗狗的日常碎片合集，从晨起的赖床到深夜的捣乱，每一帧都让人忍不住嘴角上扬。',
    featured: false,
    addedAt: '2026-09-16',
  },
  {
    id: 'v4004',
    title: '美食三十秒',
    cover: 'https://readdy.ai/api/search-image?query=short%20video%20poster%20of%20a%20close%20up%20of%20sizzling%20street%20food%20on%20a%20grill%20with%20rising%20steam%20in%20warm%20amber%20light%2C%20warm%20amber%20and%20deep%20charcoal%20tones%2C%20appetizing%20soft%20lighting%2C%20atmospheric%20depth%2C%20high%20detail%2C%20tempting%20close%20composition%2C%20no%20text&width=600&height=338&seq=tx-short-04&orientation=landscape',
    category: 'short',
    categoryLabel: '短视频',
    genre: '美食',
    year: 2025,
    region: '中国大陆',
    tags: ['美食', '教程', '烟火气'],
    rating: 7.9,
    summary: '三十秒学会一道街头人气小吃，从选料到出锅一气呵成，让你在家也能复刻夜市里的那口香。',
    featured: false,
    addedAt: '2026-09-08',
  },
  {
    id: 'v4005',
    title: '城市夜行者',
    cover: 'https://readdy.ai/api/search-image?query=short%20video%20poster%20of%20a%20lonely%20night%20street%20with%20warm%20amber%20glowing%20windows%20and%20a%20cyclist%20passing%20by%2C%20warm%20amber%20and%20deep%20charcoal%20tones%2C%20moody%20cinematic%20lighting%2C%20atmospheric%20depth%2C%20high%20detail%2C%20quiet%20evocative%20composition%2C%20no%20text&width=600&height=338&seq=tx-short-05&orientation=landscape',
    category: 'short',
    categoryLabel: '短视频',
    genre: '纪录',
    year: 2025,
    region: '日本',
    tags: ['城市', '夜晚', '氛围'],
    rating: 8.2,
    summary: '当城市安静下来，镜头记录环卫工、便利店店员与末班车司机，看见深夜依然运转的温柔力量。',
    featured: false,
    addedAt: '2026-08-26',
  },
];